module.exports = __webpack_public_path__ + "asset/school--005487.svg";